import { withPrefix, isRootPath } from 'utils/prefix'

const markCurrentItem = currentSlug => itm => {
	if (typeof currentSlug === 'undefined') {
		return itm
	}

	if (!itm.url) {
		return itm
	}

	if (isRootPath(itm.url)) {
		return {
			...itm,
			current: isRootPath(currentSlug),
		}
	}

	if (currentSlug.endsWith('/')) {
		currentSlug = currentSlug.slice(0, -1)
	}

	if (itm.virtual) {
		return {
			...itm,
			current: currentSlug.startsWith(withPrefix(itm.urlForCurrent ?? itm.url)),
		}
	}

	return {
		...itm,
		current: currentSlug === withPrefix(itm.urlForCurrent ?? itm.url),
	}
}

export const deepMarkCurrentItems = (currentSlug, items) => {
	if (!items) return undefined

	return items.map(itm => {
		return {
			...markCurrentItem(currentSlug)(itm),
			items: itm.items ? deepMarkCurrentItems(currentSlug, itm.items) : undefined,
		}
	})
}

export default markCurrentItem
